import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon, ClockIcon } from 'lucide-react';
export function Pricing() {
  const checkoutUrl = 'https://7vtxaf-x1.myshopify.com/cart/45821756342458:1';
  return <section id="comprar" className="w-full bg-black text-white py-20 md:py-32 px-4" data-id="element-71">
      <div className="max-w-5xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-73">
          <div className="inline-block bg-red-600 text-white px-6 py-3 rounded-full mb-8 font-bold text-lg" data-id="element-74">
            <ClockIcon className="inline w-5 h-5 mr-2" data-id="element-75" />
            Oferta por tiempo limitado
          </div>

          <div className="mb-8" data-id="element-76">
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" data-id="element-77">
              <img src="https://cdn.magicpatterns.com/uploads/8oir4cejC94Ra5gXcAVHun/ChatGPT_Image_5_may_2026,_01_57_43_a.m..png" alt="Sistema completo" className="w-80 mx-auto cursor-pointer hover:scale-105 transition-transform duration-300" data-id="element-78" />
            </a>
          </div>

          <p className="text-2xl md:text-3xl mb-4 line-through text-gray-400" data-id="element-79">
            Valor real: $30.990 ARS
          </p>

          <motion.div animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} data-id="element-80">
            <p className="text-6xl md:text-8xl font-black text-yellow-400 mb-8" data-id="element-81">
              Hoy: $19.990 ARS
            </p>
          </motion.div>

          <div className="flex justify-center gap-4 mb-12 text-lg md:text-xl" data-id="element-82">
            <div className="flex items-center gap-2" data-id="element-83">
              <ZapIcon className="w-6 h-6 text-yellow-400" data-id="element-84" />
              <span data-id="element-85">Pago único</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-86">
              <ZapIcon className="w-6 h-6 text-yellow-400" data-id="element-87" />
              <span data-id="element-88">Acceso inmediato</span>
            </div>
          </div>

          <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0 0 20px rgba(249, 115, 22, 0.5)', '0 0 40px rgba(249, 115, 22, 0.8)', '0 0 20px rgba(249, 115, 22, 0.5)']
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-black text-2xl md:text-4xl px-16 py-8 rounded-xl shadow-2xl transition-all duration-300 w-full md:w-auto" data-id="element-89">
            COMPRAR AHORA
          </motion.a>

          <p className="text-sm text-gray-400 mt-6" data-id="element-90">
            Acceso instantáneo después del pago • Garantía de satisfacción
          </p>
        </motion.div>
      </div>
    </section>;
}